import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('pagos-universidades'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('pagos-universidades'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`pagos-universidades/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`pagos-universidades/${id}`));
  },
  async findOneComprobante(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades/${id}/comprobante`), opciones);
  },
  async findAllPagosUniversidadesCuotaAnterior(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('pagos-universidades/cuota-anterior'), { params: opciones.params });
  },
};
